import { render, staticRenderFns } from "./logoHuddle.vue?vue&type=template&id=745741a8&scoped=true&"
import script from "./logoHuddle.vue?vue&type=script&lang=js&"
export * from "./logoHuddle.vue?vue&type=script&lang=js&"
import style0 from "./logoHuddle.vue?vue&type=style&index=0&id=745741a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745741a8",
  null
  
)

export default component.exports